// we don't care about this rule in hook utils files
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

export function useOnUnmount(effect: () => void) {
  // On unmount, call the effect
  useEffect(() => effect, [])
}
